<template>
  <div />
</template>

<script>
import {AUTH_REQUEST_PROVIDER} from "@/store/constant";
export default {
  name: 'ProviderAuth',
  mounted() {
    this.auth()
  },
  methods: {
    auth() {
      const provider = this.$route.params.provider;
      this.$store.dispatch(AUTH_REQUEST_PROVIDER, {provider, query: this.$route.fullPath.split('?')[1]})
      .then(() => {
        this.$router.push({ name: 'events' });
      })
      .catch(() => {
        this.$router.push({ name: 'login' });
      })
    }
  }
}
</script>
